import { Box, Button, Img, Input, Select, Text } from "@chakra-ui/react";
import React from "react";
import pin from "../asset/pinterest.png";
export const Introducation = () => {
  return (
    <Box mt="4rem" display={{ base:'block', sm: 'block', md: 'flex' }} boxShadow="rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px" borderBottomRadius="2rem" >
      <Box>
        <Img src={pin} />
      </Box>
      <Box boxShadow="-5px 2px 6px 0px rgba(196,196,196,1)" p="1rem" borderRadius="10px" w={{base:"100%" , sm:"100%" , md:"30%"}} >
        <Box bg="blue.400" color="white" borderRadius="10px" p="5px" mb="2rem" boxShadow="rgba(0, 0, 0, 0.15) 0px 3px 3px 0px;">
          <Text fontSize="12px" fontWeight="700" >
            Get a quotation from FliqaIndia
          </Text>
          <Text fontSize="10px">
            Fill the deatils and get on call back within next working hours
          </Text>
        </Box>
        <Box>
          <Box display="flex" alignItem="center" gap="10px" mb="10px">
            <svg
              width="31"
              height="31"
              viewBox="0 0 31 31"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.6605 27.1663C22.0049 27.1663 27.1481 22.0195 27.1481 15.6707C27.1481 9.32182 22.0049 4.17505 15.6605 4.17505C9.31603 4.17505 4.17285 9.32182 4.17285 15.6707C4.17285 22.0195 9.31603 27.1663 15.6605 27.1663Z"
                fill="#3E4357"
              />
              <path
                d="M15.6604 30.3412C23.7571 30.3412 30.3207 23.773 30.3207 15.6706C30.3207 7.56826 23.7571 1 15.6604 1C7.56367 1 1 7.56826 1 15.6706C1 23.773 7.56367 30.3412 15.6604 30.3412Z"
                stroke="#3E4357"
                stroke-miterlimit="10"
              />
              <path
                d="M28.5703 16.3847C28.9642 16.3847 29.2836 16.0651 29.2836 15.6709C29.2836 15.2766 28.9642 14.957 28.5703 14.957C28.1763 14.957 27.8569 15.2766 27.8569 15.6709C27.8569 16.0651 28.1763 16.3847 28.5703 16.3847Z"
                fill="#3E4357"
              />
              <path
                d="M2.75043 16.3847C3.14439 16.3847 3.46376 16.0651 3.46376 15.6709C3.46376 15.2766 3.14439 14.957 2.75043 14.957C2.35648 14.957 2.03711 15.2766 2.03711 15.6709C2.03711 16.0651 2.35648 16.3847 2.75043 16.3847Z"
                fill="#3E4357"
              />
              <path
                d="M16.9759 16.4153C18.7251 15.6862 19.5524 13.6762 18.8239 11.9258C18.0953 10.1754 16.0867 9.34752 14.3375 10.0766C12.5884 10.8057 11.761 12.8157 12.4896 14.5661C13.2182 16.3164 15.2268 17.1444 16.9759 16.4153Z"
                fill="white"
              />
              <path
                d="M15.6604 17.9478C13.3016 17.9478 11.2885 18.8849 10.4702 20.2119C10.1201 20.7855 10.5358 21.5213 11.2098 21.5213H20.111C20.7849 21.5213 21.2007 20.7855 20.8506 20.2119C20.0322 18.8849 18.0192 17.9478 15.6604 17.9478Z"
                fill="white"
              />
            </svg>
            <Input placeholder="Name" border="none" borderBottom="1px solid" />
          </Box>
          <Box display="flex" alignItem="center" gap="10px" mb="10px">
            <svg
              width="31"
              height="31"
              viewBox="0 0 31 31"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.6605 27.1661C22.0049 27.1661 27.1481 22.0193 27.1481 15.6704C27.1481 9.32157 22.0049 4.1748 15.6605 4.1748C9.31603 4.1748 4.17285 9.32157 4.17285 15.6704C4.17285 22.0193 9.31603 27.1661 15.6605 27.1661Z"
                fill="#3E4357"
              />
              <path
                d="M15.6604 30.3412C23.7571 30.3412 30.3207 23.773 30.3207 15.6706C30.3207 7.56826 23.7571 1 15.6604 1C7.56367 1 1 7.56826 1 15.6706C1 23.773 7.56367 30.3412 15.6604 30.3412Z"
                stroke="#3E4357"
                stroke-miterlimit="10"
              />
              <path
                d="M28.5703 16.3844C28.9642 16.3844 29.2836 16.0648 29.2836 15.6706C29.2836 15.2764 28.9642 14.9568 28.5703 14.9568C28.1763 14.9568 27.8569 15.2764 27.8569 15.6706C27.8569 16.0648 28.1763 16.3844 28.5703 16.3844Z"
                fill="#3E4357"
              />
              <path
                d="M2.75043 16.3844C3.14439 16.3844 3.46376 16.0648 3.46376 15.6706C3.46376 15.2764 3.14439 14.9568 2.75043 14.9568C2.35648 14.9568 2.03711 15.2764 2.03711 15.6706C2.03711 16.0648 2.35648 16.3844 2.75043 16.3844Z"
                fill="#3E4357"
              />
              <path
                d="M21.3671 18.1274C21.2927 18.0136 20.7982 17.7727 20.7982 17.7727C20.6012 17.6764 19.1527 16.9669 18.8814 16.8662C18.6495 16.783 18.3825 16.6866 18.1462 17.0414C17.9668 17.3085 17.4416 17.9216 17.2666 18.1143C17.1484 18.25 17.0346 18.2938 16.7677 18.1625C16.7239 18.1406 15.4329 17.5888 14.5445 16.8005C13.7568 16.1042 13.2098 15.2415 13.0085 14.9043C12.886 14.6984 12.9647 14.6021 13.1179 14.4488C13.2098 14.3569 13.6212 13.862 13.6518 13.8182C13.7174 13.7175 13.8312 13.481 13.8312 13.481C13.9494 13.2489 13.875 13.0474 13.8093 12.9117C13.7612 12.8197 13.0216 11.0286 12.9472 10.8622C12.7372 10.3586 12.5096 10.3323 12.2952 10.341C12.1901 10.3498 11.2055 10.3542 10.8948 10.6958L10.8466 10.7571C10.5403 11.0811 9.90137 11.7599 9.90137 13.0693C9.90137 13.3715 9.94951 13.6868 10.0502 14.0372C10.234 14.6678 10.5884 15.3597 11.0611 15.9903C11.0698 16.0035 11.7919 17.0019 12.1507 17.418C13.2886 18.7274 14.5708 19.6952 15.8662 20.2032C17.5204 20.8513 18.2293 21.0002 18.6319 21.0002C18.807 21.0002 19.179 20.9126 19.2577 20.9039C19.7654 20.8601 20.9645 20.2339 21.2183 19.5288C21.4546 18.8588 21.459 18.2763 21.3671 18.1274Z"
                fill="white"
              />
            </svg>

            <Input placeholder="Contact Number" border="none" borderBottom="1px solid" />
          </Box>
          <Box display="flex" alignItem="center" gap="10px" mb="10px">
            <svg
              width="31"
              height="74"
              viewBox="0 0 31 74"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.6605 70.1661C22.0049 70.1661 27.1481 65.0193 27.1481 58.6704C27.1481 52.3216 22.0049 47.1748 15.6605 47.1748C9.31603 47.1748 4.17285 52.3216 4.17285 58.6704C4.17285 65.0193 9.31603 70.1661 15.6605 70.1661Z"
                fill="#3E4357"
              />
              <path
                d="M15.6604 73.3412C23.7571 73.3412 30.3207 66.773 30.3207 58.6706C30.3207 50.5683 23.7571 44 15.6604 44C7.56367 44 1 50.5683 1 58.6706C1 66.773 7.56367 73.3412 15.6604 73.3412Z"
                stroke="#3E4357"
                stroke-miterlimit="10"
              />
              <path
                d="M28.5703 59.3844C28.9642 59.3844 29.2836 59.0648 29.2836 58.6706C29.2836 58.2764 28.9642 57.9568 28.5703 57.9568C28.1763 57.9568 27.8569 58.2764 27.8569 58.6706C27.8569 59.0648 28.1763 59.3844 28.5703 59.3844Z"
                fill="#3E4357"
              />
              <path
                d="M2.75044 59.3844C3.1444 59.3844 3.46376 59.0648 3.46376 58.6706C3.46376 58.2764 3.1444 57.9568 2.75044 57.9568C2.35648 57.9568 2.03711 58.2764 2.03711 58.6706C2.03711 59.0648 2.35648 59.3844 2.75044 59.3844Z"
                fill="#3E4357"
              />
              <path
                d="M22.5048 54.9656V63.0498C22.5048 63.7505 21.9402 64.3811 21.24 64.3811H10.0894C9.38921 64.3811 8.81592 63.7505 8.81592 63.0498V54.9656C8.81592 54.265 9.38483 53.757 10.0894 53.757H11.3148V54.4883C11.3148 54.9919 11.7042 55.3992 12.2075 55.3992C12.7108 55.3992 13.1002 54.9875 13.1002 54.4883V53.757H18.2292V54.4883C18.2292 54.9919 18.6187 55.3992 19.1219 55.3992C19.6208 55.3992 20.0147 54.9875 20.0147 54.4883V53.757H21.2444C21.9402 53.757 22.5048 54.2606 22.5048 54.9656Z"
                fill="white"
              />
              <path
                d="M21.4414 57.4269H9.87939V63.1856H21.4414V57.4269Z"
                fill="#3E4357"
              />
              <path
                d="M12.3957 58.3071H10.6846V60.0194H12.3957V58.3071Z"
                fill="white"
              />
              <path
                d="M15.1437 58.3071H13.4326V60.0194H15.1437V58.3071Z"
                fill="white"
              />
              <path
                d="M17.8923 58.3071H16.1812V60.0194H17.8923V58.3071Z"
                fill="white"
              />
              <path
                d="M20.6359 58.3071H18.9248V60.0194H20.6359V58.3071Z"
                fill="white"
              />
              <path
                d="M12.3957 60.7288H10.6846V62.4411H12.3957V60.7288Z"
                fill="white"
              />
              <path
                d="M15.1437 60.7288H13.4326V62.4411H15.1437V60.7288Z"
                fill="white"
              />
              <path
                d="M17.8923 60.7288H16.1812V62.4411H17.8923V60.7288Z"
                fill="white"
              />
              <path
                d="M20.6359 60.7288H18.9248V62.4411H20.6359V60.7288Z"
                fill="white"
              />
              <path
                d="M12.2029 54.9701C11.9185 54.9701 11.6865 54.738 11.6865 54.4533V53.4811C11.6865 53.1965 11.9185 52.9644 12.2029 52.9644C12.4874 52.9644 12.7193 53.1965 12.7193 53.4811V54.4533C12.7193 54.738 12.4874 54.9701 12.2029 54.9701Z"
                fill="white"
              />
              <path
                d="M19.0999 54.9701C18.8154 54.9701 18.5835 54.738 18.5835 54.4533V53.4811C18.5835 53.1965 18.8154 52.9644 19.0999 52.9644C19.3843 52.9644 19.6163 53.1965 19.6163 53.4811V54.4533C19.6163 54.738 19.38 54.9701 19.0999 54.9701Z"
                fill="white"
              />
              <path
                d="M15.6605 27.1663C22.0049 27.1663 27.1481 22.0195 27.1481 15.6707C27.1481 9.32182 22.0049 4.17505 15.6605 4.17505C9.31603 4.17505 4.17285 9.32182 4.17285 15.6707C4.17285 22.0195 9.31603 27.1663 15.6605 27.1663Z"
                fill="#3E4357"
              />
              <path
                d="M15.6604 30.3412C23.7571 30.3412 30.3207 23.773 30.3207 15.6706C30.3207 7.56826 23.7571 1 15.6604 1C7.56367 1 1 7.56826 1 15.6706C1 23.773 7.56367 30.3412 15.6604 30.3412Z"
                stroke="#3E4357"
                stroke-miterlimit="10"
              />
              <path
                d="M28.5703 16.3847C28.9642 16.3847 29.2836 16.0651 29.2836 15.6709C29.2836 15.2766 28.9642 14.957 28.5703 14.957C28.1763 14.957 27.8569 15.2766 27.8569 15.6709C27.8569 16.0651 28.1763 16.3847 28.5703 16.3847Z"
                fill="#3E4357"
              />
              <path
                d="M2.75044 16.3845C3.1444 16.3845 3.46375 16.065 3.46375 15.6707C3.46375 15.2765 3.1444 14.9569 2.75044 14.9569C2.35648 14.9569 2.03711 15.2765 2.03711 15.6707C2.03711 16.065 2.35648 16.3845 2.75044 16.3845Z"
                fill="#3E4357"
              />
              <path
                d="M21.3758 11.265H9.94071C9.39805 11.265 8.95605 11.7073 8.95605 12.2504V19.0908C8.95605 19.6338 9.39805 20.0761 9.94071 20.0761H21.3758C21.9184 20.0761 22.3604 19.6338 22.3604 19.0908V12.2504C22.3648 11.7073 21.9228 11.265 21.3758 11.265ZM21.5683 12.4036L15.783 15.618C15.748 15.6355 15.713 15.6487 15.6736 15.6487H15.6429C15.6035 15.6487 15.5642 15.6399 15.5335 15.618L9.74815 12.4036C9.63875 12.3423 9.59935 12.2022 9.66062 12.0927C9.72189 11.9832 9.86194 11.9438 9.97134 12.0051L15.6604 15.1669L21.3495 12.0051C21.4589 11.9438 21.599 11.9832 21.6602 12.0927C21.7171 12.2066 21.6778 12.3423 21.5683 12.4036Z"
                fill="white"
              />
            </svg>
            <Input placeholder="Mail Id" border="none" borderBottom="1px solid" />
            
          </Box>
          <Box display="flex" alignItem="center" gap="10px" mb="10px">
            <svg
              width="31"
              height="31"
              viewBox="0 0 31 31"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.6605 27.1661C22.0049 27.1661 27.1481 22.0193 27.1481 15.6704C27.1481 9.32157 22.0049 4.1748 15.6605 4.1748C9.31603 4.1748 4.17285 9.32157 4.17285 15.6704C4.17285 22.0193 9.31603 27.1661 15.6605 27.1661Z"
                fill="#3E4357"
              />
              <path
                d="M15.6604 30.3412C23.7571 30.3412 30.3207 23.773 30.3207 15.6706C30.3207 7.56826 23.7571 1 15.6604 1C7.56367 1 1 7.56826 1 15.6706C1 23.773 7.56367 30.3412 15.6604 30.3412Z"
                stroke="#3E4357"
                stroke-miterlimit="10"
              />
              <path
                d="M28.5703 16.3844C28.9642 16.3844 29.2836 16.0648 29.2836 15.6706C29.2836 15.2764 28.9642 14.9568 28.5703 14.9568C28.1763 14.9568 27.8569 15.2764 27.8569 15.6706C27.8569 16.0648 28.1763 16.3844 28.5703 16.3844Z"
                fill="#3E4357"
              />
              <path
                d="M2.75043 16.3844C3.14439 16.3844 3.46376 16.0648 3.46376 15.6706C3.46376 15.2764 3.14439 14.9568 2.75043 14.9568C2.35648 14.9568 2.03711 15.2764 2.03711 15.6706C2.03711 16.0648 2.35648 16.3844 2.75043 16.3844Z"
                fill="#3E4357"
              />
              <path
                d="M21.3671 18.1274C21.2927 18.0136 20.7982 17.7727 20.7982 17.7727C20.6012 17.6764 19.1527 16.9669 18.8814 16.8662C18.6495 16.783 18.3825 16.6866 18.1462 17.0414C17.9668 17.3085 17.4416 17.9216 17.2666 18.1143C17.1484 18.25 17.0346 18.2938 16.7677 18.1625C16.7239 18.1406 15.4329 17.5888 14.5445 16.8005C13.7568 16.1042 13.2098 15.2415 13.0085 14.9043C12.886 14.6984 12.9647 14.6021 13.1179 14.4488C13.2098 14.3569 13.6212 13.862 13.6518 13.8182C13.7174 13.7175 13.8312 13.481 13.8312 13.481C13.9494 13.2489 13.875 13.0474 13.8093 12.9117C13.7612 12.8197 13.0216 11.0286 12.9472 10.8622C12.7372 10.3586 12.5096 10.3323 12.2952 10.341C12.1901 10.3498 11.2055 10.3542 10.8948 10.6958L10.8466 10.7571C10.5403 11.0811 9.90137 11.7599 9.90137 13.0693C9.90137 13.3715 9.94951 13.6868 10.0502 14.0372C10.234 14.6678 10.5884 15.3597 11.0611 15.9903C11.0698 16.0035 11.7919 17.0019 12.1507 17.418C13.2886 18.7274 14.5708 19.6952 15.8662 20.2032C17.5204 20.8513 18.2293 21.0002 18.6319 21.0002C18.807 21.0002 19.179 20.9126 19.2577 20.9039C19.7654 20.8601 20.9645 20.2339 21.2183 19.5288C21.4546 18.8588 21.459 18.2763 21.3671 18.1274Z"
                fill="white"
              />
            </svg>

            <Input placeholder="Contact Number" border="none" borderBottom="1px solid" />
          </Box>

<Box ><Select borderRadius="50px" color="black"> <option >Package you are looking</option> </Select></Box>
 <Button colorScheme='twitter' w="100%" mt="10px">SUBMIT</Button>
        </Box>
      </Box>
    </Box>
  );
};
